import React from 'react';
import { FormControl, InputBase, InputBaseProps, InputLabel, Select, withStyles } from '@material-ui/core';
import FormHelperText from '@material-ui/core/FormHelperText';
import { SelectInputProps } from '@material-ui/core/Select/SelectInput';
import { MenuListProps } from '../../constants';
import { TooltipedInfoIcon } from '../TooltipedIcon';
import { TextFieldProps } from './types';

export const Input = withStyles(theme => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(2) + 2,
        },
    },
    input: {
        borderRadius: 10,
        position: 'relative',
        backgroundColor: theme.palette.common.white,
        border: '1px solid #DCDCDC',
        padding: '10px 12px',
        '&:focus': {
            borderRadius: 10,
        }
    },
}))(InputBase);

const TextField = React.forwardRef(({
    label, id, select, className, required, helpertext, error, margin, tooltip, onChange, ...other
}: TextFieldProps, forwardRef) => {
    const textFieldLabel = label && (
        <InputLabel style={{ marginLeft: '6px' }} shrink htmlFor={id} error={!!error}>
            {label}
            {tooltip && (
                <TooltipedInfoIcon tooltip={tooltip} tooltipFontSize='1rem' />
            )}
        </InputLabel>
    );

    return (
        // TODO: It seems form control margins take too much space. Espessialy on mobile, I think we can disable it
        <FormControl fullWidth className={className} margin={margin || 'normal'} required={required}>
            {textFieldLabel}
            {select
                    ? (
                        <Select
                            onChange={onChange as SelectInputProps['onChange']}
                            {...other}
                            id={id}
                            labelId={id}
                            input={<Input />}
                            MenuProps={MenuListProps}
                        />
                    )
                    : (
                        <Input
                            onChange={onChange as InputBaseProps['onChange']}
                            {...other}
                            ref={forwardRef}
                            id={id}
                        />
                    )}
            <FormHelperText error={!!error}>{helpertext}</FormHelperText>
        </FormControl>
    );
});

export default TextField;
